import React, { useContext } from 'react';
import classes from './NeedToChangeRulesBeforeSavePrompt.module.scss';
import { CreateAudienceDialogContext } from '../CreateAudienceDialogContext';
import { Warning } from '@walkme/wm-ui-icons';
import { useTranslation } from 'react-i18next';

const keyPrefix = 'components.audiences.createAudienceDialog.needToChangeRulesBeforeSavePrompt';

const NeedToChangeRulesBeforeSavePrompt = () => {
    const { t } = useTranslation('', { keyPrefix });
    const { dataTestId } = useContext(CreateAudienceDialogContext);

    return (
        <div className={classes.warnPrompt} data-testid={`${dataTestId}-change-rules-before-save-prompt`}>
            <Warning style={{ flexShrink: 0, marginRight: 10 }} />
            <div>
                <div>
                    <b>{t('sameAudienceExists')}</b>
                </div>
                <div>{t('modifyAudienceRulesToSaveDuplicated')}</div>
            </div>
        </div>
    );
};

export default NeedToChangeRulesBeforeSavePrompt;
